import React from 'react';

export default function RedCollarSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size * 0.5} viewBox="0 0 40 20" fill="none" className={className}>
      {/* Collar band */}
      <path
        d="M2 8C2 8 10 14 20 14C30 14 38 8 38 8L38 14C38 14 30 20 20 20C10 20 2 14 2 14Z"
        fill="#D32F2F"
      />
      {/* Collar top edge */}
      <path
        d="M2 8C2 8 10 12 20 12C30 12 38 8 38 8"
        stroke="#B71C1C"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Tag */}
      <circle cx="20" cy="18" r="4" fill="#FFD54F" />
      <circle cx="20" cy="18" r="2.5" fill="#FFB300" />
      {/* Buckle */}
      <rect x="8" y="9" width="4" height="4" rx="0.5" fill="#FFD54F" stroke="#FFB300" strokeWidth="0.5" />
    </svg>
  );
}
